import { useMutation, useQueryClient } from "@tanstack/react-query";

import { CreateNpsSurveyType } from "@/domain/npsSurveys";

import { NpsSurveysApi } from "../api/npsSurveysApi";
import { ApplicationsQueryKeys } from "../queries/applicationsQueries";

export const useCreateNpsSurveyMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: CreateNpsSurveyType) =>
      NpsSurveysApi.createNpsSurvey(params),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ApplicationsQueryKeys.all,
      });
    },
  });
};
